import { WebView as RNWebView } from 'react-native-webview';

import { CameraOptions, FlipMode } from 'components/camera/types';

export type CampaignRouteParams = {
  campaignSlug?: string;
};

export enum CampaignMessage {
  initiateLogin = 'CAMPAIGN::INITIATE_LOGIN',
  loginComplete = 'CAMPAIGN::LOGIN_COMPLETE',
  requestUser = 'CAMPAIGN::REQUEST_USER',
  requestPlatform = 'CAMPAIGN::REQUEST_PLATFORM',
  showOneTrustDialog = 'CAMPAIGN::SHOW_ONE_TRUST_DIALOG',
  requestDevice = 'CAMPAIGN::REQUEST_DEVICE',
  navigateTo = '^CAMPAIGN::NAVIGATE::(.+)$',
  onDismiss = '^CAMPAIGN::ON_DISMISS::(.+)$',
  share = '^CAMPAIGN::SHARE::((https?://[^:]*|data:[^:]+|[^:]+))::MESSAGE::(.*?)$',
  download = '^CAMPAIGN::DOWNLOAD::(.+)::MESSAGE::(.*?)$',
  startStopSensors = '^CAMPAIGN::SENSORS::(.*)$',
  checkSensorsAvailability = 'CAMPAIGN::CHECK_SENSORS_AVAILABILITY',
  requestOrientation = 'CAMPAIGN::REQUEST_ORIENTATION',
  setOrientationUnlocked = 'CAMPAIGN::SET_ORIENTATION_UNLOCKED',
  setOrientation = '^CAMPAIGN::SET_ORIENTATION::(PORTRAIT|LANDSCAPE)?$',
  postEvent = '^CAMPAIGN::CUSTOM_EVENT::(.+)::PAYLOAD::(.*?)$',
  getLocalStorage = 'CAMPAIGN::GET_LOCAL_STORAGE',
  setLocalStorage = '^CAMPAIGN::SET_LOCAL_STORAGE::(.+)$',
  requestCameraAccess = '^CAMPAIGN::REQUEST_CAMERA_ACCESS::(FRONT|BACK|BOTH::BACK|BOTH::FRONT)(::OPTIONS::.+)?$',
  requestSafeAreaInsets = 'CAMPAIGN::GET_SAFE_AREA_INSETS',
  loadingFinished = 'CAMPAIGN::LOADING_FINISHED',
  toast = '^CAMPAIGN::TOAST::VARIANT::(INFO|SUCCESS|ERROR|NEUTRAL)::MESSAGE::(.+)$',
}

export type ToastVariant = 'INFO' | 'SUCCESS' | 'ERROR' | 'NEUTRAL';

export type HandlersType = {
  [key: string]: (...args: any[]) => void;
};

export interface IWebviewProps {
  onMessageReceived: (message: string) => void;
  externalUrl: string;
  onLoadEnd: () => void;
  queryParam: string;
  backgroundColor: string;
  testID?: string;
  webViewRef: React.RefObject<RNWebView | HTMLIFrameElement | null>;
}

type SuccessDownloadMessage = {
  message: string;
  title: string;
};

export type SaveFileProps = {
  url: string;
  fileName: string;
  successDownloadMessage?: SuccessDownloadMessage;
};

export type DownloadFileFromUrlProps = {
  url: string;
  successDownloadMessage?: SuccessDownloadMessage;
};

export enum ScreenOrientation {
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE',
}

export type CameraConfiguration = {
  flip: FlipMode;
  options: CameraOptions;
};
